var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.06,
    height: 44.138,
    viewBox: "0 0 37.06 44.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.667,0c-.941,0-1.711,.77-1.711,1.711V42.428c0,.941,.77,1.711,1.711,1.711h29.683c.941,0,1.711-.77,1.711-1.711V11.035L26.026,0H5.667Z",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.715,23.931v12.513c0,.688-.502,1.251-1.116,1.251H3.956v-13.764c0-.688,.502-1.251,1.115-1.251H29.6c.614,0,1.116,.563,1.116,1.251Z",
    fill: "#722e2b",
    "mix-blend-mode": "multiply",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.784,11.035h8.276L26.026,0V8.276c0,1.517,1.241,2.759,2.759,2.759Z",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.784,11.035h8.276L26.026,0V8.276c0,1.517,1.241,2.759,2.759,2.759Z",
    fill: "#4ba6dd",
    "mix-blend-mode": "color",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.982,35.222c0,.688-.562,1.251-1.249,1.251H1.249C.562,36.473,0,35.91,0,35.222v-12.513c0-.688,.562-1.251,1.249-1.251H28.733c.687,0,1.249,.563,1.249,1.251v12.513Z",
    fill: "#e04b3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.002,33.559h-1.655v-9.021h3.032c1.251,0,1.92,.202,2.426,.72,.467,.506,.669,1.149,.669,2.147,0,1.087-.24,1.782-.796,2.274-.493,.442-1.149,.619-2.299,.619h-1.377v3.26Zm1.377-4.599c1.036,0,1.453-.455,1.453-1.555s-.417-1.541-1.453-1.541h-1.402v3.096h1.402Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.113,24.538h3.058c2.362-.038,3.487,1.111,3.424,3.499v2.021c.063,2.388-1.049,3.525-3.424,3.5h-3.058v-9.021Zm2.767,7.694c1.528,.024,2.034-.544,2.059-2.3v-1.769c-.025-1.757-.531-2.325-2.059-2.3h-1.112v6.368h1.112Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.612,24.538h5.483v1.352h-3.829v2.502h3.222v1.352h-3.222v3.815h-1.655v-9.021Z",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.c19a933a190fa46c6983cf3425f264c3.svg";
export { ForwardRef as ReactComponent };